import { createReducer } from "@reduxjs/toolkit";
import {
  INTERACTIVE_LOADING,
  LIST_INTERACTIVE,
  LOAD_INTERACTIVE,
  LOAD_INTERACTIVE_ERROR,
} from "../actions/types";

const initialState = {
  data: {},
  error: false,
  loading: false,
  list: [],
  thisPage: 0,
  allPages: 0,
  count: 0,
};

const interactiveReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(INTERACTIVE_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(LOAD_INTERACTIVE, (state, { payload }) => {
      state.data = payload;

      state.error = false;
      state.loading = false;
    })
    .addCase(LOAD_INTERACTIVE_ERROR, (state, { payload }) => {
      state.loading = false;
      state.error = payload;
    })
    .addCase(LIST_INTERACTIVE, (s, { payload }) => {
      s.list =
        payload?.thisPage === 1
          ? payload?.data
          : [...s?.list, ...payload?.data];
      s.count = payload.count;
      s.allPages = payload.allPages;
      s.thisPage = payload.thisPage;
      s.loading = false;
    });
});

export default interactiveReducer;
